import { render, staticRenderFns } from "./Tablepm.vue?vue&type=template&id=4381350e&scoped=true&"
import script from "./Tablepm.vue?vue&type=script&lang=js&"
export * from "./Tablepm.vue?vue&type=script&lang=js&"
import style0 from "./Tablepm.vue?vue&type=style&index=0&id=4381350e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4381350e",
  null
  
)

export default component.exports